<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-size-select-large"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-right mb-5">
          <v-btn
              class="btn-add-templates"
              @click="addDimension"
          >
            Add Template Type
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="white mx-1">
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="listTemplateType"
              class="elevation-1"
              :sort-by="['index']"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <v-dialog
              v-model="dialogAddType"
              v-if="dialogAddType"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <ValidationObserver ref="addTemplateSize">
                <v-card-title>
                  <span class="text-h5 mx-3">Add Template Type</span>
                </v-card-title>
                <v-card-text>
                  <v-row align="center" justify="center">
                    <v-col class="mt-4" cols="11">
                      <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="name"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Name"
                            placeholder="Enter name"
                            v-model="name"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <div class="mb-2 primary--text">Index<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="index"
                          rules="required|numeric"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Index"
                            placeholder="Enter index"
                            v-model="index"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row align="center" justify="center" class="mb-4">
                    <v-btn class="mr-5" @click="dialogAddType = false">CANCEL</v-btn>
                    <v-btn class="btn" @click="save">SAVE</v-btn>
                  </v-row>
                </v-card-actions>
              </ValidationObserver>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="dialogEditType"
              v-if="dialogEditType"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <ValidationObserver ref="editTemplateType">
              <v-card-title>
                <span class="text-h5 mx-3">Edit Template Type</span>
              </v-card-title>
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col class="mt-4" cols="11">
                    <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                    <ValidationProvider
                        name="name"
                        rules="required"
                        v-slot="{ errors }"
                    >
                    <v-text-field
                        filled
                        label="Name"
                        placeholder="Enter name"
                        v-model="templateTypeDetail.name"
                    ></v-text-field>
                      <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col class="mt-4" cols="11">
                    <div class="mb-2 primary--text">Index<span class="necessary">(*)</span></div>
                    <ValidationProvider
                        name="index"
                        rules="required|numeric"
                        v-slot="{ errors }"
                    >
                    <v-text-field
                        filled
                        label="Index"
                        placeholder="Enter index"
                        v-model="templateTypeDetail.index"
                    ></v-text-field>
                      <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row align="center" justify="center" class="mb-4">
                  <v-btn class="mr-5" @click="dialogEditType = false">CANCEL</v-btn>
                  <v-btn class="btn" @click="update">UPDATE</v-btn>
                </v-row>
              </v-card-actions>
              </ValidationObserver>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_TEMPLATE_TYPE,
  GET_DETAIL_TEMPLATE_TYPE,
  GET_LIST_TEMPLATE_TYPE,
  SAVE_TEMPLATE_TYPE, UPDATE_TEMPLATE_TYPE
} from "../../../store/modules/template_type";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";

export default {
  name: "Template_Type",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: "Templates",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Template Type",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Name", value: "name"},
        {text: "Index", value: "index"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      dialogAddType: false,
      dialogEditType: false,
      index: '',
      name: '',
    }
  },
  computed: {
    ...mapGetters({
      listTemplateType: "listTemplateType",
      templateTypeDetail: "templateTypeDetail",
    })
  },
  mounted() {
    localize({
      vi: {
        names: {
          name: "Name",
          index: "Index",
        },
        messages: {
          required: "{_field_} " + "is empty!",
          numeric: "{_field_} " + "is not a number!",
        },
      },
    });
    localize("vi");
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE_TYPE);
  },
  methods: {
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_TEMPLATE_TYPE}`, id).then((data) => {
        if (data) {
          this.dialogEditType = true;
        }
      });
    },
    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_TEMPLATE_TYPE}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_TEMPLATE_TYPE);
        }
      })
    },
    addDimension() {
      this.dialogAddType = true
    },
    async update() {
      let result = this.$refs.editTemplateType.validate();
      if(result){
        if(!this.templateTypeDetail.name || !this.templateTypeDetail.index){
          return false;
        }else{
          let payload = {
            name: this.templateTypeDetail.name,
            index : this.templateTypeDetail.index
          }
          let data = {
            id: this.templateTypeDetail.id,
            data: payload
          }
          await this.$store.dispatch(`${UPDATE_TEMPLATE_TYPE}`, data).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              this.dialogEditType = false
              this.$store.dispatch(GET_LIST_TEMPLATE_TYPE);
            } else {
              alert(data.data.errors)
            }
          });
        }

      }

    },
    async save() {
      let result = this.$refs.addTemplateSize.validate();
      if (result) {
        if (!this.name || !this.index) {
          return false;
        } else {
          let payload = {
            name: this.name,
            index :this.index
          }
          await this.$store.dispatch(`${SAVE_TEMPLATE_TYPE}`, payload).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              this.dialogAddType = false
              this.$store.dispatch(GET_LIST_TEMPLATE_TYPE);
            } else {
              alert(data.data.errors)
            }
          });
        }
      }

    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.btn {
  background-color: #71BEC8 !important;
  color: white !important;
}

.necessary {
  color: red;
}

</style>